import { AppBar, Card, CardContent, CardHeader, Grid, Icon, Tab, Tabs, Tooltip, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { getCurrencySemSinalMonetario } from 'app/utils/monetarioUtil';
import React, { useEffect, useState } from 'react';
import { MdHelp } from 'react-icons/md';
import GraficoLine from '../Grafico/GraficoLine';
import VisaoGeralLoading from '../VisaoGeralLoading';
import { dashboardTabStyles } from './styles';

const DashboardTab = ({
  titulo = '',
  subtitulo = '',
  totalVendas = 0,
  abas = [],
  buscarDadosGrafico = async () => {},
  trendingUp = false,
  evolucaoVendas,
  categorias = [],
  dadosGrafico = [],
  className
}) => {
  const [abaSelecionada, setAbaSelecionada] = useState(0);
  const [loading, setLoading] = useState(false);

  const HelperTooltip = withStyles((theme) => ({
    tooltip: {
      maxWidth: 200,
      fontSize: theme.typography.pxToRem(12),
    },
  }))(Tooltip);

  const classes = dashboardTabStyles();

  const widthAba = abas.length === 0 ? 0 : 100 / abas.length;

  const buscarDados = async () => {
    setLoading(true);

    await buscarDadosGrafico(abaSelecionada);

    setLoading(false);
  };

  useEffect(() => {
    buscarDados();
    // Efeito reativo apenas ao gatilho acima; incluir as demais reiniciaria o formulário durante a edição.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [abaSelecionada]);

  const series = [
    {
      name: titulo,
      data: dadosGrafico,
    },
  ];

  const msgVendasAprovadas = (aba, index) => {
    const icone = <div style={{ display: 'flex', alignItems: 'center' }}>{aba}</div>;

    switch (aba) {
      case 'Semana':
        return (
          <HelperTooltip key={index} title="Vendas aprovadas nos últimos 7 dias.">
            <Tab style={{ minWidth: `${widthAba}%` }} label={icone} value={index} />
          </HelperTooltip>
        );

      case 'Mês':
        return (
          <HelperTooltip key={index} title="Vendas aprovadas nas últimas 4 semanas.">
            <Tab style={{ minWidth: `${widthAba}%` }} label={icone} value={index} />
          </HelperTooltip>
        );

      case 'Ano':
        return (
          <HelperTooltip key={index} title="Vendas aprovadas nos últimos 12 meses.">
            <Tab style={{ minWidth: `${widthAba}%` }} label={icone} value={index} />
          </HelperTooltip>
        );

      default:
        break;
    }
  };

  return (
    <Card className={className}>
      <CardHeader
        title={
          <>
            <Grid container>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div style={{ marginRight: 10 }}>
                    <Typography variant="h5">{titulo} </Typography>
                  </div>
                  <HelperTooltip
                    title="Os valores correspondem ao somatório das vendas aprovadas. Os contratos não são considerados."
                    placement="right"
                  >
                    <div>
                      <MdHelp size={20} />
                    </div>
                  </HelperTooltip>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography>{subtitulo}</Typography>
              </Grid>
            </Grid>
            <Grid container className={classes.valorVendas}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography variant="h4" className={classes.headerEvolucaoVendas}>
                  {getCurrencySemSinalMonetario(totalVendas)}
                </Typography>
                {!!evolucaoVendas && (
                  <div className={classes.headerEvolucaoVendas}>
                    {trendingUp ? (
                      <Icon fontSize="small" className={classes.trendingUp}>
                        trending_up
                      </Icon>
                    ) : (
                      <Icon fontSize="small" className={classes.trendingDown}>
                        trending_down
                      </Icon>
                    )}
                    <Typography className={classes.evolucaoVenda}>
                      {getCurrencySemSinalMonetario(evolucaoVendas)}% em relação ao mês anterior
                    </Typography>
                  </div>
                )}
              </Grid>
            </Grid>
          </>
        }
        classes={{ root: classes.root }}
      />
      <CardContent style={{ padding: 0 }}>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <AppBar position="static">
              <Tabs
                value={abaSelecionada}
                onChange={(event, novaAba) => setAbaSelecionada(novaAba)}
                classes={{ indicator: classes.tabIndicator }}
              >
                {abas.map((aba, index) => msgVendasAprovadas(aba, index))}
              </Tabs>
            </AppBar>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className={classes.graficoLine}>
            {loading ? (
              <VisaoGeralLoading size={50} style={{ minHeight: '300px' }} />
            ) : (
              <GraficoLine categorias={categorias} conteudo={series} height="300px" />
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default DashboardTab;
